import React from "react";
import { Tag } from "antd";

interface ChipsTagsAntdComponentIF {
  filterState: any;
  onCloseHandler?: any;
  chipsFields: any;
  isShowCross?: any;
}
const ChipsTagsAntdComponent: React.FC<ChipsTagsAntdComponentIF> = ({
  filterState,
  onCloseHandler,
  chipsFields,
  isShowCross = false,
}: ChipsTagsAntdComponentIF) => {
  return (
    <div className="d-flex">
      {Object.keys(filterState).map((ele: any) => {
        return (chipsFields &&
          chipsFields[ele] &&
          typeof chipsFields[ele] != "object" &&
          chipsFields[ele]["label"] != undefined) ||
          (chipsFields && chipsFields[ele] && chipsFields[ele] != undefined) ? (
          <>
            <Tag
              closeIcon={isShowCross}
              onClose={() => onCloseHandler(ele)}
              style={{
                textAlign: "center",
                textTransform: "capitalize",
              }}
            >
              {typeof chipsFields[ele] != "object"
                ? chipsFields[ele]
                : chipsFields[ele]["label"]}
            </Tag>
          </>
        ) : null;
      })}
    </div>
  );
};

export default ChipsTagsAntdComponent;
